import { formatDate as formatDateFn } from '@vueuse/core';
import { DateTime } from 'luxon';

import { ListEntry } from '@silae/helpers';
import { DateFormat } from '~/domain/date.domain';

export function formatDate(timeStamp: number, format = DateFormat.LONG_WITH_HOURS, locale = 'fr-FR'): string {
	if (!timeStamp) {
		return null;
	}
	return formatDateFn(new Date(timeStamp), format, { locales: locale });
}

export function yearMonthToString(year: number, month: number): string {
	const monthAsString = month < 10 ? `0${month}` : month;
	return `${year}-${monthAsString}`;
}

export function getLastBillingDateObj(creationDate: DateTime = DateTime.now()): DateTime {
	const lastBillingDateObj = DateTime.now().minus({ month: 1 });

	if (lastBillingDateObj.year === creationDate.year && lastBillingDateObj.month === creationDate.month) {
		return creationDate;
	}

	return lastBillingDateObj;
}

export function generateYearMonthItems(
	creationDate: DateTime = DateTime.now(),
	locale = 'fr',
	disabledPredicate?: (year: number, month: number) => boolean
): ListEntry<string>[] {
	let result: ListEntry<string>[] = [];
	const lastBillingDate = getLastBillingDateObj(creationDate);
	const lastBillingDateYear = lastBillingDate.year;
	const lastBillingDateMonth = lastBillingDate.month;

	const creationDateYear = creationDate?.year;
	const creationDateMonth = creationDate?.month;

	if (creationDateYear > lastBillingDateYear && creationDateMonth > lastBillingDateMonth) {
		throw new Error('Partner creation date cannot be after first billing date !');
	}

	const yearIteration = lastBillingDateYear - creationDateYear + 1;

	// For each year between creation date and last billing date, we iterate:
	for (let i = 0; i < yearIteration; i++) {
		const year = lastBillingDateYear - i;
		// Then, we need to calculate starting and ending indexes for given year
		let startingIndex = 1;
		let endingIndex = 12;

		if (lastBillingDateYear === creationDateYear) {
			startingIndex = creationDateMonth;
			endingIndex = lastBillingDateMonth;
		} else {
			//case: last billing date year is strictly lower than creation date year
			if (year === lastBillingDateYear) {
				endingIndex = lastBillingDateMonth;
				startingIndex = 1;
			}

			if (year === creationDateYear) {
				endingIndex = 12;
				startingIndex = creationDateMonth;
			}
		}

		// After calculating starting and ending indexes, we can iterate over relevant months
		for (let month = endingIndex; month >= startingIndex; month--) {
			const item = {
				label: `${DateTime.local(year, month).monthLong} ${year}`,
				value: yearMonthToString(year, month),
				disabled: disabledPredicate?.(year, month) ?? false
			};
			result.push(item);
		}
	}

	return result;
}
